import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import {
  FormRow,
  FormLabel,
  FormFieldWrapper,
  FormRowProps
} from '../form-input';
import { languages } from 'screens/retailer/localization-helpers';
import { useTranslation } from 'react-i18next';

interface LanguageFieldProps extends FormRowProps {
  label: string;
  value: string;
  onChange: (value?: string) => void;
  disabled?: boolean;
}

export function LanguageField(props: LanguageFieldProps) {
  const { label, value, onChange, disabled, ...formRowProps } = props;

  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <FormFieldWrapper>
        <Select
          value={value}
          onChange={handleChange}
          disabled={disabled}
          fullWidth
        >
          <MenuItem key={'autoDetect'} value={'autoDetect'}>
            {t('autoDetectLocale')}
          </MenuItem>
          {languages.map(lang => (
            <MenuItem key={lang} value={lang}>
              {t(lang)}
            </MenuItem>
          ))}
        </Select>
      </FormFieldWrapper>
    </FormRow>
  );
}
